import { QuestionType } from "../types/questionType";

type Order = Pick<QuestionType, "order">;
export const sortByOrder = (a: Order, b: Order) => (a.order > b.order ? 1 : -1);
